import { connectLogger } from '@reatom/framework'
import { ru } from 'date-fns/locale/ru'
import { registerLocale } from 'react-datepicker'

import { DEMO_MODE } from '@root/shared'
import { addToGlobal } from '@root/shared/lib'
import { rootCtx } from '@root/shared/lib/reatom/root-ctx'

import * as appMain from './app-main'

import type { Ctx } from '@reatom/framework'
import type { TestCtx } from '@reatom/testing'

// TODO: Ivan - registering Russian locale for react-datepicker, move elsewhere
registerLocale('ru', ru)

const favicon = document.createElement('link')
favicon.rel = 'icon'
favicon.type = 'image/x-icon'
favicon.href = import.meta.env.DEV ? '/favicon-dev.svg' : '/favicon.svg'
document.head.appendChild(favicon)

const createAppCtx = async () => {
  if (DEMO_MODE) {
    const demoMode = await import('./demo-mode')
    demoMode.demoMode(rootCtx as TestCtx)
  }
  return rootCtx
}

/**
 * `app-main` is imported at the top rather than awaited here.
 *
 * It was `await import('./app-main')`, which reads as code splitting but is
 * not: nothing renders without it, so the only thing the dynamic import
 * bought was hiding the chunk from the build. Measured in `dist`, the
 * emitted `index.html` carries a `modulepreload` for every *static* import
 * of the entry — the runtime, Sentry, styled-components, both locales — and
 * **not** for `app-main`, which is 2.6 MB, the largest chunk by a factor of
 * six.
 *
 * So the browser could not even learn that file existed until it had
 * downloaded, parsed and executed the entry. Three serial round trips where
 * one would do, on a link where one round trip costs 269ms.
 *
 * Making it static lets the build declare it in the document, so it
 * downloads alongside the entry instead of behind it. The bytes are
 * unchanged; the discovery is not.
 */
export const run = async () => {
  const ctx: Ctx = await createAppCtx()

  addToGlobal('__CTX', ctx)

  if (import.meta.env.VITE_LOG_REATOM === 'true') {
    connectLogger(ctx)
  }

  appMain.run(ctx)
}
